module.exports = __webpack_public_path__ + "static/media/lifeline_step_9_neg.d814e58c.png";